import { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

import { CardColor } from '@/types'

import './Badge.scss'

interface BadgeProps extends PropsWithChildren {
    color?: CardColor
    value?: number | string
    maxValue?: number
    className?: string
}

export const Badge: FC<BadgeProps> = ({
    color = CardColor.secondary,
    value,
    maxValue = 99,
    className = '',
    children,
}): ReactElement => {
    const isIndicator = children === undefined
    const displayValue = typeof value === 'number' && value > maxValue ? `${maxValue}+` : value

    const badgeClassName = classNames('badge', {
        [`badge--${color}`]: color,
        'badge--dot': isIndicator && value === undefined,
        'badge--count': isIndicator && value !== undefined,
    }, className)

    return (
        <span className={badgeClassName} aria-hidden={isIndicator ? true : undefined}>
            {isIndicator ? displayValue : children}
        </span>
    )
}
